/**
 * CSV Format Help Component.
 * Displays CSV file format requirements and column specifications for device import.
 *
 * @param {Object} props
 * @param {Object} props.classes - Material-UI style classes
 */
import { Trans } from '@lingui/macro';
import { Box, Typography } from '@material-ui/core';

export default function CsvFormatHelp({ classes }) {
    return (
        <Box className={classes.helpSection}>
            <Typography className={classes.helpTitle}>
                <Trans>File format: ASCII or Unicode text file</Trans>
            </Typography>
            <ul className={classes.helpList}>
                <li>
                    <Trans>The first line must be the header row</Trans>
                </li>
                <li>
                    <Trans>Comma or tab separated values</Trans>
                </li>
                <li>
                    <Trans>File extension: .csv or .txt</Trans>
                </li>
            </ul>
            <Typography className={classes.helpTitle}>
                <Trans>Columns:</Trans>
            </Typography>
            <ol className={classes.helpList}>
                <li>
                    <strong>IP Address: </strong>
                    <Trans>IP address (required)</Trans>
                </li>
                <li>
                    Description: <Trans>text (optional)</Trans>
                </li>
                <li>
                    Name: <Trans>text (optional)</Trans>
                </li>
                <li>
                    DNS Name: <Trans>text (optional)</Trans>
                </li>
                <li>
                    SNMP Name: <Trans>text (optional)</Trans>
                </li>
                <li>
                    Device Type:{' '}
                    <Trans>
                        optional, default is New. Accepted values: New, Unknown, Server, Router, Switch, Firewall,
                        Packet-Processor
                    </Trans>
                </li>
            </ol>
        </Box>
    );
}
